module.exports = __webpack_public_path__ + "media/images/screens/03_sousNav_v1-89c1592954e66cde16d5d72886318215.jpg";